import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import LandingPage from "@/pages/LandingPage";
import BookingPage from "@/pages/BookingPage";
import StudiesPage from "@/pages/StudiesPage";
import PublicationsPage from "@/pages/PublicationsPage";
import NewsPage from "@/pages/NewsPage";
import NewsletterPage from "@/pages/NewsletterPage";
import NewslettersPage from "@/pages/NewslettersPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/buchen" element={<BookingPage />} />
            <Route path="/studien" element={<StudiesPage />} />
            <Route path="/publikationen" element={<PublicationsPage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/newsletter/:id" element={<NewsletterPage />} />
            <Route path="/newsletters" element={<NewslettersPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
